<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
import LaisGalleryTabBar from 'dashboard/components-next/LaisGalleryTabBar.vue';
import PropertyCarousel from 'dashboard/components-next/gallery/PropertyCarousel.vue';
import LaisFavoriteButton from 'dashboard/components-next/lais/LaisFavoriteButton.vue';

defineProps({
  galleryTabs: {
    type: Array,
    default: () => [],
  },
  mediaTabs: {
    type: Array,
    default: () => [],
  },
  activeGalleryItems: {
    type: Array,
    default: () => [],
  },
  galleryEmptyMessage: {
    type: String,
    default: '',
  },
  mapUrl: {
    type: String,
    default: null,
  },
  imovel: {
    type: Object,
    default: () => ({}),
  },
  contactId: {
    type: Number,
    default: null,
  },
  businessContext: {
    type: String,
    default: '',
  },
  favorited: {
    type: Boolean,
    default: false,
  },
  favoriteId: {
    type: [Number, String],
    default: null,
  },
});

const emit = defineEmits([
  'openLightbox',
  'selectGalleryTab',
  'toggleFavorite',
]);

const GALLERY_TABS_ID = 'imovel-gallery-tabs';

const galleryTab = defineModel('galleryTab', {
  type: String,
  required: true,
});
const midiaIndex = defineModel('midiaIndex', {
  type: Number,
  required: true,
});

const openGalleryTab = tab => emit('selectGalleryTab', tab);

const galleryTabId = id => `${GALLERY_TABS_ID}-tab-${id}`;
const galleryPanelId = id => `${GALLERY_TABS_ID}-panel-${id}`;
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
  <LaisGalleryTabBar
    v-model="galleryTab"
    :tabs="galleryTabs"
    id-base="imovel-gallery-tabs"
    aria-label="Galeria do imóvel"
  />

  <div
    :id="galleryPanelId(galleryTab)"
    role="tabpanel"
    :aria-labelledby="galleryTabId(galleryTab)"
    tabindex="0"
    class="min-w-0 outline-none focus-visible:shadow-lais-focus"
  >
    <PropertyCarousel
      v-if="galleryTab !== 'mapa'"
      v-model="midiaIndex"
      :items="activeGalleryItems"
      :media-tabs="mediaTabs"
      :empty-message="galleryEmptyMessage"
      @open="emit('openLightbox', $event)"
      @select-tab="openGalleryTab"
    />
    <div v-if="galleryTab !== 'mapa'" class="mt-4 flex flex-wrap gap-2">
      <LaisFavoriteButton
        class="hidden sm:inline-flex"
        :listing="imovel"
        :contact-id="contactId"
        position="gallery_desktop"
        :business-context="businessContext"
        :initially-favorited="favorited"
        :initial-favorite-id="favoriteId"
        @toggle="emit('toggleFavorite', $event)"
      />
      <LaisFavoriteButton
        class="sm:hidden"
        :listing="imovel"
        :contact-id="contactId"
        position="gallery_mobile"
        :business-context="businessContext"
        :initially-favorited="favorited"
        :initial-favorite-id="favoriteId"
        @toggle="emit('toggleFavorite', $event)"
      />
    </div>

    <div
      v-else
      class="overflow-hidden rounded-lais border border-lais-border bg-white"
    >
      <iframe
        v-if="mapUrl"
        :src="mapUrl"
        title="Mapa do imóvel"
        class="h-[420px] w-full border-0"
        loading="lazy"
      />
      <div
        v-else
        class="grid h-[320px] place-items-center text-[14px] text-lais-text-muted"
      >
        Endereço insuficiente para montar o mapa.
      </div>
    </div>
  </div>
</template>
